import { useSelector } from 'react-redux';

import { Description } from '@mui/icons-material';
import { selectSalesFunnel, selectSalesFunnelLoading } from 'features/sales/salesSlice';

import { FunnelDiv, Icon, Lead, Status, Value } from './Funnel.styles';

const Funnel = ({ background }) => {
  const funnelData = useSelector(selectSalesFunnel);
  const isLoading = useSelector(selectSalesFunnelLoading);
  if (isLoading) {
    return (
      <FunnelDiv>
        <div>Loading...</div>
      </FunnelDiv>
    );
  }
  return (
    <FunnelDiv>
      {/* {funnelData?.map((item, index) => (
        <Lead
          key={index}
          width={item.width || '80%'}
          background={item.background || background}
        >
          <Status>{item.status || `Status ${index + 1}`}</Status>
          <Value>{item.value || 0}</Value>
          <Description>{item.description || '0.0% of total'}</Description>
          {index < funnelData.length - 1 && <Icon src={arrow} alt="down-arrow" />}
        </Lead>
      )) || (
        <Lead width={'80%'} background={background}>
          <Status>No data available</Status>
          <Value>0</Value>
          <Description>0.0% of total</Description>
        </Lead>
      )} */}
    </FunnelDiv>
  );
};

export default Funnel;
